module.exports = __webpack_public_path__ + "static/media/paginate-last.2863988c.svg";